import { render } from "./Change.vue?vue&type=template&id=130b1ba8"
import script from "./Change.vue?vue&type=script&lang=ts"
export * from "./Change.vue?vue&type=script&lang=ts"
script.render = render

export default script